<div
	[ngClass]="['vtr-widget-permission-note', 'p-4', (noteType && 'permission-' + noteType + '-note') || '']" >
	<div class="d-flex">
		<div *ngIf="icon">
			<span
				role="img"
				[class]="'align-self-start permission-note-icon icomoon ' + icon">
				<span class="path1" aria-hidden="true"></span>
				<span class="path2" aria-hidden="true"></span>
			</span>
		</div>

		<div class="row">
			<div class="col-12">
				<div id="{{linkId}}-note-title" attr.aria-label="{{ noteTitle }}, {{ description }}">
					<strong *ngIf="noteTitle">{{ noteTitle }}:</strong>
					{{ description }}
					<ng-container *ngIf="linkInLine">
						<ng-container *ngTemplateOutlet="linkButton"></ng-container>
					</ng-container>
				</div>
				<ng-container *ngIf="!linkInLine">
					<ng-container *ngTemplateOutlet="linkButton"></ng-container>
				</ng-container>
			</div>
		</div>
	</div>
</div>

<ng-template #linkButton>
	<button type="button"
		role="link"
		tabindex="0"
		id="{{linkId}}-link"
		attr.aria-label="{{pathText}}"
		class="privacy-button pl-0"
		(click)="onClick($event)"
		[disabled]="linkDisabled"
		*ngIf="!noPath">
		{{pathText}}
	</button>
</ng-template>
